const endpoint = (payload) => Promise.resolve(payload);

const mock = { endpoint };

export default mock;
